export const CAM_ROT_VELOCITY = 3;
export const CAM_MOUSE_ZOOM_MULT = 0.05;
export const CAM_MOUSE_PAN_MULT = 20;
